<header>
    <mat-toolbar color="primary" class="mat-toolbar mat-primary mat-toolbar-single-row">
        <button *ngIf="!isLoggedOut" mat-icon-button id="homeButton" (click)="onHomeClick()" routerLink="dashboard" routerLinkActive="active" class="mat-focus-indicator icons mat-icon-button mat-button-base mat-button-home">
            <span class="mat-button-wrapper">
                <mat-icon  role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">home</mat-icon>
            </span>
            <span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
            <span class="mat-button-focus-overlay"></span>
        </button>
        <span id="env" class="display-tag mode">{{envName}}</span>
        <span class="app-toolbar-filler"></span>
        <span *ngIf="!isLoggedOut" id="user" class="display-tag">{{clientUser}}</span>
        <div aria-labelledby="logo" title="Progressive Small Business" id="logo">
        </div>
        <button *ngIf="!isLoggedOut" mat-icon-button id="logoutButton" (click)="onLogoutClick()" class="mat-focus-indicator icons mat-icon-button mat-button-base mat-button-logout">
            <span class="mat-button-wrapper">
                <mat-icon  role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">exit_to_app</mat-icon>
            </span>
            <span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
            <span class="mat-button-focus-overlay"></span>
        </button>
    </mat-toolbar>
</header>